<template>
  <Modal v-model="modal" :title="$t('name.cex_take.create.title')" width="1000" footer-hide>
    <div class="page-box-content" style="padding-bottom:0">
      <Form ref="form" :model="form">
        <Row :gutter="20">
          <Col :span="6">
            <FormItem :label="$t('name.cex_take.create.cex')">
              <Cascader :data="cex" @on-change="(value, data) => { this.id = value[1] }" />
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem :label="$t('name.cex_take.create.date')">
              <div style="width: 100%; display: inline-block">
                <DatePicker v-model="date" type="date" style="width: 100%" :clearable="false"/>
              </div>
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem :label="$t('name.cex_take.create.time')">
              <div style="width: 100%; display: inline-block">
                <TimePicker v-model="time" type="timerange" format="HH:mm" :steps="[1, 30]" style="width:100%" :clearable="false" />
              </div>
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem :label="$t('name.cex_take.create.observ')">
              <Input v-model="form.observ" />
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <Address ref="address" :title="$t('name.cex_take.create.address')" />
    <div style="text-align: center; padding-bottom: 20px">
      <Button type="primary" size="large" :loading="loading" @click="onPost">{{ $t('name.cex_take.create.title') }}</Button>
    </div>
  </Modal>
</template>
<script>
import Address from '../address/address'
import { get } from '@/api/cex';
import { create } from '@/api/cex_take';

export default {
  components: {
    Address
  },
  data() {
    return {
      id: 0,
      cex: [],
      modal: false,
      loading: false,
      form: {
        fechaRecogida: '',
        horaDesde1: '',
        horaHasta1: '',
        observ: ''
      },
      date: new Date,
      time: ['00:00', '23:00']
    }
  },
  created(){
    // 加载线路
    get().then(res => {
      // 整理线路
      const handle = (data) => {
        return data.map(item => {
          return {
            value: item.id,
            label: item.name,
            children: item.cex ? handle(item.cex) : [],
            disabled: item.status !== undefined ? !item.status : false,
            ...item,
          }
        })
      }
      
      this.cex = handle(res)
    })
  },
  methods: {
    open() {
      this.modal = true
      this.form.observ = ''
    },
    async onPost() {
      // 补零
      const zero = num => {
        return num < 10 ? '0' + num.toString() : num
      }
      // 填充数据
      this.form.fechaRecogida = zero(this.date.getDate()) + '-' + zero((this.date.getMonth() + 1).toString()) + '-' + this.date.getFullYear().toString()
      this.form.horaDesde1 = this.time[0]
      this.form.horaHasta1 = this.time[1]
      
      // 地址 
      const address = await this.$refs.address.get()
      if(!address) return
      
      this.form.nomRemit = address.name
      this.form.contRecog = address.contact
      this.form.tlfnoRecog = address.phone
      this.form.dirRecog = address.address + ' ' + address.number + (address.house ? ', ' + address.house : '')
      this.form.poblRecog = address.city
      this.form.cpRecog = address.zip
      
      // 开始提交
      this.loading = true
      create(this.id, this.form).then(res => {
        this.loading = false
        this.modal = false
        this.$emit('create')
        this.$Message.success(this.$t('message.' + res.message))
        
        // 更新地址
        this.$refs.address.put()
      }).catch(res => {
        this.loading = false
        if(res.error == 101) {
          return this.$Message.error(res.message)
        }
        this.$Message.error(this.$t('message.' + res.message))
      })
    }
  }
}
</script>